import { NativeDateAdapter } from '@angular/material/core';
import { Injectable } from '@angular/core';
import { SupportedLanguage } from '@app/utils/constants/supported-languages';

// Thai's CLDR default calendar is Buddhist, so NativeDateAdapter (via Intl.DateTimeFormat)
// renders Buddhist-era years in the Material datepicker (e.g. 2569 instead of 2026). Force the
// Gregorian calendar via the BCP-47 `-u-ca-gregory` extension.
const THAI_GREGORIAN_LOCALE = 'th-u-ca-gregory';

@Injectable({
  providedIn: 'root',
})
export class CustomDateAdapter extends NativeDateAdapter {
  override setLocale(locale: string): void {
    super.setLocale(locale === SupportedLanguage.Th ? THAI_GREGORIAN_LOCALE : locale);
  }

  override getFirstDayOfWeek(): number {
    switch (this.locale) {
      case SupportedLanguage.En:
      case SupportedLanguage.Id:
      case SupportedLanguage.Ko:
      case SupportedLanguage.Pt:
      case THAI_GREGORIAN_LOCALE:
      case SupportedLanguage.ZhHant:
        return 0; // Sunday
      case SupportedLanguage.Es:
      case SupportedLanguage.Ja:
      case SupportedLanguage.Vi:
      case SupportedLanguage.ZhHans:
      default:
        return 1; // Monday
    }
  }
}
